__turbopack_context__.v({
  "container": "UnfavouritePrizeModal-module__Ot3aDG__container",
  "image": "UnfavouritePrizeModal-module__Ot3aDG__image",
  "prizeImage": "UnfavouritePrizeModal-module__Ot3aDG__prizeImage",
  "prizeTitle": "UnfavouritePrizeModal-module__Ot3aDG__prizeTitle",
});
